import { ContainerModule } from 'inversify'
import { TYPES } from '@/plugins/cad/module/container/types'
import { globalCadI18n as CAD_I18N_INSTANCE } from '@/plugins/cad/module/i18n/globalI18n'
import { AuxiliaryMouseHelper } from './auxiliaryTool/auxiliaryMouseHelper'
import { CaptureHelper } from './auxiliaryTool/captureHelper'
import { GridHelper } from './auxiliaryTool/gridHelper'
import { MouseTipHelper } from './auxiliaryTool/MouseTipHelper'
import { OrthogonalHelper } from './auxiliaryTool/OrthogonalHelper'
import { PointCloudHelper } from './auxiliaryTool/pointCloudHelper'
import { PolarHelper } from './auxiliaryTool/polarHelper'
import { CADController } from './CADController'
import { CADDefaultTool } from './CADDefaultTool'
import { DrawAngularDimensionTool } from './draw/drawAngularDimensionTool'
import { DrawArcTool } from './draw/drawArcTool'
import { DrawCircleTool } from './draw/drawCircleTool'
import { DrawDimensionTool } from './draw/drawDimensionTool'
import { DrawEllipseTool } from './draw/drawEllipseTool'
import { DrawHatchTool } from './draw/drawHatchTool'
import { DrawMLeaderTool } from './draw/drawMLeaderTool'
import { DrawPolygonTool } from './draw/drawPolygonTool'
import { DrawPolylineTool } from './draw/drawPolylineTool'
import { DrawRayTool } from './draw/drawRayTool'
import { DrawRectTool } from './draw/drawRectTool'
import { DrawSplineTool } from './draw/drawSplineTool'
import { DrawTextTool } from './draw/drawTextTool'
import { BreakEntityTool } from './edit/breakEntityTool'
import { CloseEntityTool } from './edit/closeEntityTool'
import { CopyEntityTool } from './edit/copyEntityTool'
import { ExtendEntityTool } from './edit/extendEntityTool'
import { JoinEntityTool } from './edit/joinEntityTool'
import { MoveEntityTool } from './edit/moveEntityTool'
import { OffsetEntityTool } from './edit/offsetEntityTool'
import { RotateEntityTool } from './edit/rotateEntityTool'
import { TrimEntityTool } from './edit/trimEntityTool'
import { CADViewManager } from './manager/CADViewManager'
import { HistoryManager } from './manager/HistoryManager'
import { EntityDetector } from './selector/entityDetector'
import { EntitySelector } from './selector/entitySelector'

/**
 * CAD 模块的 inversify 容器绑定配置，注册控制器、管理器、绘制/编辑工具与辅助工具。
 */
export const CADModule = new ContainerModule(({ bind }) => {
  bind(TYPES.CADController).to(CADController).inSingletonScope()
  bind(TYPES.CADViewManager).to(CADViewManager).inSingletonScope()
  bind(TYPES.CADDefaultTool).to(CADDefaultTool).inSingletonScope()
  bind(TYPES.EntityDetector).to(EntityDetector).inSingletonScope()
  bind(TYPES.EntitySelector).to(EntitySelector).inSingletonScope()
  bind(TYPES.HistoryManager).to(HistoryManager).inSingletonScope()
  /** 绘制 */
  bind(TYPES.DrawPolylineTool).to(DrawPolylineTool).inSingletonScope()
  bind(TYPES.DrawArcTool).to(DrawArcTool).inSingletonScope()
  bind(TYPES.DrawCircleTool).to(DrawCircleTool).inSingletonScope()
  bind(TYPES.DrawRectTool).to(DrawRectTool).inSingletonScope()
  bind(TYPES.DrawSplineTool).to(DrawSplineTool).inSingletonScope()
  bind(TYPES.DrawTextTool).to(DrawTextTool).inSingletonScope()
  bind(TYPES.DrawDimensionTool).to(DrawDimensionTool).inSingletonScope()
  bind(TYPES.DrawPolygonTool).to(DrawPolygonTool).inSingletonScope()
  bind(TYPES.DrawEllipseTool).to(DrawEllipseTool).inSingletonScope()
  bind(TYPES.DrawRayTool).to(DrawRayTool).inSingletonScope()
  bind(TYPES.DrawHatchTool).to(DrawHatchTool).inSingletonScope()
  bind(TYPES.DrawMLeaderTool).to(DrawMLeaderTool).inSingletonScope()
  bind(TYPES.DrawAngularDimensionTool).to(DrawAngularDimensionTool).inSingletonScope()
  /** 编辑 */
  bind(TYPES.MoveEntityTool).to(MoveEntityTool).inSingletonScope()
  bind(TYPES.CopyEntityTool).to(CopyEntityTool).inSingletonScope()
  bind(TYPES.JoinEntityTool).to(JoinEntityTool).inSingletonScope()
  bind(TYPES.CloseEntityTool).to(CloseEntityTool).inSingletonScope()
  bind(TYPES.RotateEntityTool).to(RotateEntityTool).inSingletonScope()
  bind(TYPES.OffsetEntityTool).to(OffsetEntityTool).inSingletonScope()
  bind(TYPES.BreakEntityTool).to(BreakEntityTool).inSingletonScope()
  bind(TYPES.TrimEntityTool).to(TrimEntityTool).inSingletonScope()
  bind(TYPES.ExtendEntityTool).to(ExtendEntityTool).inSingletonScope()
  /** i18n — 使用全局单例，与 CAD.setTranslator() 共享同一实例 */
  bind(TYPES.CadI18nService).toConstantValue(CAD_I18N_INSTANCE)
  /** 辅助工具 */
  bind(TYPES.MouseTipHelper).to(MouseTipHelper).inSingletonScope()
  bind(TYPES.OrthogonalHelper).to(OrthogonalHelper).inSingletonScope()
  bind(TYPES.CaptureHelper).to(CaptureHelper).inSingletonScope()
  bind(TYPES.GridHelper).to(GridHelper).inSingletonScope()
  bind(TYPES.PolarHelper).to(PolarHelper).inSingletonScope()
  bind(TYPES.PointCloudHelper).to(PointCloudHelper).inSingletonScope()
  bind(TYPES.AuxiliaryMouseHelper).to(AuxiliaryMouseHelper).inSingletonScope()
})
